import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close mobile menu when route changes
    useEffect(() => {
        setIsOpen(false);
    }, [location]);

    const navItems = ['Home', 'About', 'Services', 'Projects', 'Contact'];

    return (
        <nav className={`fixed w-full z-50 transition-all duration-300 bg-gradient-to-br from-blue-900 to-blue-800 ${scrolled ? 'bg-gradient-to-br from-blue-900 to-blue-600 shadow-lg' : 'bg-transparent'
            }`}>
            <div className="max-w-7xl mx-auto px-4">
                {/* Main Navigation Bar */}
                <div className="flex justify-between items-center h-16">
                    <div className="flex-shrink-0">
                        <Link
                            to="/"
                            className="font-bold text-xl text-white cursor-pointer hover:text-blue-100 transition-colors duration-200"
                        >
                            <img
                                src="/assets/logo.png"
                                alt="Escort Energi LTD"
                                className="logo"
                                style={{
                                    width: '150px',
                                    height: 'auto',
                                    objectFit: 'contain'
                                  }}
                            />
                        </Link>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex space-x-8 bg-gradient-to-r from-blue-900 to-blue-800 px-6 py-3 rounded-lg">
                        {navItems.map((item) => (
                            <Link
                                key={item}
                                to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                                className={`text-white hover:text-blue-100 transition-colors duration-200 ${location.pathname === (item === 'Home' ? '/' : `/${item.toLowerCase()}`)
                                        ? 'border-b-2 border-white'
                                        : ''
                                    }`}
                            >
                                {item}
                            </Link>
                        ))}
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-white p-2 rounded-md hover:bg-blue-500 hover:bg-opacity-20 transition-colors duration-200"
                            aria-label="Toggle menu"
                        >
                            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                        </button>
                    </div>
                </div>

                {/* Mobile Menu Overlay */}
                <div
                    className={`md:hidden fixed inset-0 bg-blue-900 bg-opacity-95 transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                        }`}
                    style={{ top: '64px' }}
                >
                    <div className="px-4 py-6 space-y-4">
                        {navItems.map((item) => (
                            <Link
                                key={item}
                                to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                                className={`block w-full text-left px-4 py-3 rounded-lg text-white text-lg font-medium hover:bg-blue-800 transition-colors duration-200 ${location.pathname === (item === 'Home' ? '/' : `/${item.toLowerCase()}`)
                                        ? 'bg-blue-800'
                                        : ''
                                    }`}
                            >
                                {item}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default NavBar;
